import React, { useEffect } from 'react'
import OurMission from '../../sections/OurMission'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const AboutUs = () => {
    const mission = {
        img: require('./../../assets/imgs/mission.jpeg'),
        head: 'Our Mission',
        des: `At Pixel Motus, we strive to create the best quality of 3D Animation and color Grading solutions that provides promising results and enhances client’s visual Presence. We aim to create relevant 3D Animation and Color Grading Solutions that are completely aligned with our client’s business and vision, utilizing our expertise and up-to-date technology, all while providing these services at reasonable prices ensuring accessibility without compromising quality.`
    }

    const strategy = {
        img: require('./../../assets/imgs/strategy.jpeg'),
        head: 'Our Strategy',
        des: `At PIXEL MOTUS, we've learned that a successful project starts with a solid strategy. Without it, even the best visuals can't reach their full potential. Our strategy is built on a three-pronged approach: engaging 3D product animations, precise color grading, and cohesive storytelling. Together, these elements create a powerful narrative that drives engagement and growth.
        We believe that video is a profound tool for connection.`,
        des2: ` By combining stunning animations with vibrant color grading, we craft visuals that not only capture attention but also evoke emotions. These emotions drive actions, turning viewers into loyal customers. To inspire action, you must first inspire feeling, and our strategy is designed to do just that.`
    }
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <div className='aboutusPage'>
            <OurMission data={mission} />
            <Row className='p-3'>
                <Col xs={12} sm={12} md={8} lg={8} xl={7} xxl={6} className='mx-auto' data-aos="zoom-in">
                    <div className='innerText2'>
                        <h1 className='text-white text-center'>Our Why</h1>
                        <p className='text-white'>At PIXEL MOTUS, storytelling through visuals is our true passion. We delight in the connection it creates with viewers and the success it generates for brands. Whether it's bringing an idea to life with 3D animation or refining visuals with color grading, we strive to create work that resonates. Our mission is to inspire, engage, and elevate. We are committed to helping brands achieve phenomenal results. When our clients excel, we excel.</p>
                    </div>

                    <Row>
                        <Col xs={8} sm={8} md={8} lg={6} xl={4} xxl={4} className='mx-auto text-center mt-3'>
                            <Link className='getInto'>Start Now</Link>
                        </Col>
                    </Row>

                </Col>
            </Row>
            <OurMission data={strategy} />
        </div>
    )
}

export default AboutUs
